import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
const faqs = [{
  question: '¿Es un curso con videos?',
  answer: 'No. Sabemos que como mamá no tenés tiempo de sentarte a ver horas de video. Es un kit de 6 ebooks en PDF, directo al grano, para que leas a tu ritmo desde el celular mientras tu hijo duerme.'
}, {
  question: '¿Sirve si mi hijo tiene 6 años?',
  answer: 'El sistema está diseñado específicamente para el desarrollo cerebral de niños de 2 a 5 años, que es la etapa más intensa de los berrinches. Si tu hijo tiene 6 o 7, muchas herramientas te van a servir, pero el enfoque principal es la primera infancia.'
}, {
  question: '¿Cómo me llega el material?',
  answer: 'Inmediatamente después de tu compra, te llega un email con el link de acceso a nuestra plataforma donde podés descargar todos los PDFs (los 6 tomos y los 9 bonos) a tu celular, tablet o computadora.'
}, {
  question: '¿Puedo imprimirlo?',
  answer: '¡Sí! Todo el material está en formato PDF de alta calidad, listo para que lo imprimas si preferís leer en papel. Las tarjetas de rutinas y la rueda de emociones están especialmente diseñadas para imprimir.'
}, {
  question: '¿Tengo que pagar una mensualidad?',
  answer: 'No. Es un pago único. Pagás una sola vez y tenés acceso de por vida a todo el material, incluyendo las futuras actualizaciones que hagamos del MegaKit.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tenés nuestra garantía de 7 días. Si lo comprás, lo leés y sentís que no es lo que esperabas, nos escribís un email y te devolvemos el 100% de tu dinero sin hacerte ninguna pregunta.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <SectionWrapper className="bg-offwhite py-20 md:py-28 px-4" data-id="element-95">
      <div className="max-w-[800px] mx-auto" data-id="element-96">
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-dark-green text-center mb-16" data-id="element-97">
          ❓ Lo que más nos preguntan
        </h2>

        <div className="space-y-4" data-id="element-98">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-sage/20 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-99">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-6 py-6 text-left transition-colors hover:bg-sage/5" data-id="element-100">
                <span className="font-poppins font-bold text-dark-green text-base md:text-lg pr-4" data-id="element-101">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="flex-shrink-0 bg-sage/10 p-2 rounded-full" data-id="element-102">
                  <ChevronDownIcon className="w-5 h-5 text-dark-green" data-id="element-103" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-104">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-105">
                    <div className="px-6 pb-6 text-dark-green/80 font-poppins text-base leading-relaxed border-t border-sage/10 pt-5" data-id="element-106">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}